import React, { createContext, useContext, useEffect, useState } from "react";
import { isBrowser } from "../utils/isBrowser";

type LanguageContext = {
  currentLanguage: string | undefined;
  setCurrentLanguage: (language: string) => void;
};

export const Languages = {
  English: "English",
  Dari: "Dari",
};

const rightHandedLanguages = ["Urdu", "Arabic", "Dari"];
const languageStorageKey = "app-language";

const LanguageContext = createContext<LanguageContext>({
  currentLanguage: Languages.English,
  setCurrentLanguage: () => {},
});

const LanguageProvider = ({ children }: { children: React.ReactNode }) => {
  const [currentLanguage, setCurrentLanguage] = useState<string | undefined>(
    () => {
      if (!isBrowser()) {
        return Languages.English;
      }
      const storedLanguage = window.localStorage.getItem(languageStorageKey);
      return storedLanguage || Languages.English;
    },
  );

  useEffect(() => {
    if (!isBrowser()) {
      return;
    }
    window.localStorage.setItem(
      languageStorageKey,
      currentLanguage || Languages.English,
    );
  }, [currentLanguage]);

  return (
    <LanguageContext.Provider value={{ currentLanguage, setCurrentLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;

export const useCurrentLanguage = () =>
  useContext(LanguageContext).currentLanguage;
export const useSetCurrentStore = () =>
  useContext(LanguageContext).setCurrentLanguage;

export const isCurrentLanguageRTL = () =>
  rightHandedLanguages.includes(
    useContext(LanguageContext).currentLanguage || "",
  );
